"use strict";

import LanguageLabels from "../../amplify/backend/function/matesonlinebookingMobLibrary/opt/LanguageLabels.js";

/**
 * The languages the app names: the locales the UI is translated into (LocaleSelect) and the
 * teaching languages a school can offer (CoursePerson, the private-lesson language step, the
 * course inquiry form).
 *
 * The names are endonyms — each language names itself — so they do not change with the active
 * locale. They used to be copied verbatim into all six locale files as `$t(code)` entries,
 * eleven identical rows per file kept in sync by hand (MOB-129). They are one table in the layer
 * module opt/LanguageLabels.js, which the order e-mail reads too (MOB-322), and no locale file
 * carries them any more.
 */
const { LANGUAGE_LABELS } = LanguageLabels;

/**
 * The 6 locales the UI is translated into (one file each in src/locales), in menu order. The
 * `locales` getter of the store falls back to this list when MOBConfig carries none, and App.vue
 * accepts exactly these codes in `?lang=` — one list, so the menu and the deep link cannot drift
 * (MOB-400). It is not the list of teaching languages (LANGUAGE_LABELS).
 */
const APP_LOCALES = Object.freeze(["cs", "en", "sk", "de", "pl", "hu"]);

class LanguageUtil {

  /** Every code this module can name, in display order. */
  static get codes() {
    return Object.keys(LANGUAGE_LABELS);
  }

  /**
   * The display name of one language code.
   *
   * Case- and whitespace-insensitive: the UI works in lower-case codes while the backend
   * stores upper-case ones (see APIAdapter.toStoredLanguageCodes), and both reach this
   * method. An unknown code is returned unchanged, which is what `$t(code)` did with a key
   * no locale file carried; a missing code renders as nothing.
   *
   * @param {string} code - ISO 639-1 code, any case
   * @returns {string}
   */
  static label(code) {
    return LanguageLabels.label(code);
  }
}

export { LANGUAGE_LABELS, APP_LOCALES };
export default LanguageUtil;
